import { useLocation } from 'react-router'

export default function useQueryParams(names) {
    const searchParams = new URLSearchParams(useLocation().search)

    return names.map(name => searchParams.get(name))
}
